import { render, staticRenderFns } from "./LicensePlateInput.vue?vue&type=template&id=fb271dac&scoped=true&"
import script from "./LicensePlateInput.vue?vue&type=script&lang=js&"
export * from "./LicensePlateInput.vue?vue&type=script&lang=js&"
import style0 from "./LicensePlateInput.vue?vue&type=style&index=0&id=fb271dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb271dac",
  null
  
)

export default component.exports